import { useState, useCallback } from 'react';

type UseToggleReturn = readonly [boolean, () => void];

/* Хук для переключения булевого состояния с мемоизированной функцией toggle*/
export const useToggle = (initialValue = false): UseToggleReturn => {
    const [state, setState] = useState<boolean>(initialValue);
    // useCallback предотвращает пересоздание toggle при каждом рендере
    const toggle = useCallback(() => {
        setState(prev => !prev);
    }, []);
    return [state, toggle] as const;
};